import { Box } from "@mui/material";
import { ScaleLoader } from "react-spinners";

const Loader: React.FC<{ loading: boolean }> = ({ loading }) => {
  if (!loading) return null;

  return (
    <Box
      sx={{
        position: 'fixed',           // Cover the entire screen
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        zIndex: 1300,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backdropFilter: 'blur(5px)',
        backgroundColor: 'rgba(255, 255, 255, 0.3)',
      }}
    >
      <ScaleLoader color="#4AD16E" speedMultiplier={1.2} />
    </Box>
  );
};

export default Loader;